<template>
  <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div class="delete-modal">
      <div class="flex justify-center">
        <svg
          width="327"
          height="259"
          viewBox="0 0 327 259"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_9157_38633)">
            <path
              d="M1.83174 58.1166C1.19142 58.2761 0.648678 58.6539 0.322579 59.1671C-0.00352009 59.6803 -0.0863554 60.2871 0.0922481 60.8544L42.0346 193.462C42.2147 194.029 42.6414 194.51 43.2212 194.798C43.8009 195.087 44.4863 195.16 45.1271 195.002L199.748 156.673C200.388 156.514 200.931 156.136 201.257 155.623C201.583 155.11 201.666 154.503 201.487 153.936L159.545 21.3277C159.365 20.7608 158.938 20.2803 158.358 19.9916C157.779 19.7029 157.093 19.6296 156.453 19.7877L1.83174 58.1166Z"
              fill="#E6E6E6"
            />
            <path
              d="M47.0708 188.741L194.415 152.216L154.51 26.0498L7.16602 62.5748L47.0708 188.741Z"
              fill="white"
            />
            <path
              d="M26.6465 79.4217C25.6634 79.6654 25.2581 81.111 25.743 82.6441C26.2279 84.1772 27.4223 85.2263 28.4053 84.9827L95.6067 68.3241C96.5897 68.0804 96.995 66.6348 96.5101 65.1017C96.0252 63.5686 94.8309 62.5195 93.8478 62.7632L26.6465 79.4217Z"
              fill="#E6E6E6"
            />
            <path
              d="M32.0585 96.5321C31.0755 96.7758 30.6702 98.2214 31.1551 99.7545C31.64 101.288 32.8344 102.337 33.8174 102.093L101.019 85.4345C102.002 85.1908 102.407 83.7452 101.922 82.2121C101.437 80.679 100.243 79.6299 99.2599 79.8735L32.0585 96.5321Z"
              fill="#E6E6E6"
            />
            <path
              d="M37.4082 113.446C36.4251 113.689 36.0198 115.135 36.5047 116.668C36.9896 118.201 38.184 119.25 39.167 119.007L106.368 102.348C107.351 102.104 107.757 100.659 107.272 99.1256C106.787 97.5925 105.593 96.5434 104.61 96.7871L37.4082 113.446Z"
              fill="#E6E6E6"
            />
            <path
              d="M42.8203 130.556C41.8372 130.8 41.4319 132.245 41.9168 133.778C42.4017 135.312 43.5961 136.361 44.5792 136.117L111.781 119.458C112.764 119.215 113.169 117.769 112.684 116.236C112.199 114.703 111.005 113.654 110.022 113.897L42.8203 130.556Z"
              fill="#E6E6E6"
            />
            <path
              d="M127.952 54.5063C127.539 54.6082 127.153 54.7812 126.816 55.0153C126.478 55.2494 126.197 55.5401 125.986 55.8707C125.776 56.2013 125.641 56.5654 125.59 56.9421C125.539 57.3189 125.572 57.7009 125.687 58.0663C125.803 58.4317 125.999 58.7733 126.263 59.0717C126.528 59.3701 126.857 59.6193 127.231 59.8051C127.604 59.991 128.016 60.1098 128.441 60.1548C128.867 60.1997 129.298 60.17 129.711 60.0673L142.274 56.9531C143.107 56.7466 143.813 56.2556 144.237 55.5882C144.661 54.9207 144.769 54.1315 144.535 53.394C144.302 52.6566 143.747 52.0314 142.994 51.656C142.24 51.2805 141.348 51.1856 140.515 51.3921L127.952 54.5063Z"
              fill="#E6E6E6"
            />
            <path
              d="M133.259 71.2851C132.846 71.387 132.46 71.56 132.122 71.7941C131.785 72.0282 131.503 72.3189 131.293 72.6495C131.082 72.9801 130.948 73.3442 130.896 73.721C130.845 74.0977 130.878 74.4797 130.994 74.8451C131.109 75.2105 131.305 75.5521 131.57 75.8505C131.835 76.1489 132.164 76.3981 132.537 76.584C132.911 76.7698 133.322 76.8886 133.748 76.9336C134.174 76.9786 134.605 76.9488 135.018 76.8461L147.581 73.7319C148.414 73.5254 149.12 73.0344 149.544 72.367C149.968 71.6995 150.075 70.9103 149.842 70.1728C149.609 69.4354 149.054 68.8102 148.3 68.4348C147.546 68.0593 146.655 67.9644 145.822 68.1709L133.259 71.2851Z"
              fill="#E6E6E6"
            />
            <path
              d="M138.567 88.0645C138.154 88.1667 137.769 88.3398 137.432 88.574C137.095 88.8082 136.813 89.0989 136.603 89.4294C136.393 89.7598 136.259 90.1237 136.208 90.5002C136.157 90.8766 136.19 91.2583 136.305 91.6235C136.421 91.9886 136.616 92.33 136.881 92.6283C137.146 92.9265 137.474 93.1757 137.847 93.3615C138.22 93.5474 138.631 93.6664 139.057 93.7117C139.482 93.757 139.913 93.7277 140.326 93.6254L152.888 90.5112C153.721 90.3047 154.428 89.8137 154.852 89.1463C155.276 88.4788 155.383 87.6896 155.15 86.9521C154.917 86.2147 154.362 85.5895 153.608 85.2141C152.854 84.8386 151.963 84.7437 151.13 84.9502L138.567 88.0645Z"
              fill="#E6E6E6"
            />
            <path
              d="M143.873 104.843C143.041 105.051 142.335 105.542 141.912 106.209C141.489 106.876 141.382 107.665 141.615 108.401C141.848 109.138 142.402 109.763 143.155 110.139C143.908 110.514 144.799 110.61 145.632 110.404L158.194 107.29C159.027 107.083 159.732 106.592 160.155 105.925C160.578 105.257 160.685 104.469 160.452 103.732C160.219 102.995 159.665 102.37 158.912 101.995C158.159 101.619 157.268 101.524 156.436 101.729L143.873 104.843Z"
              fill="#E6E6E6"
            />
            <path
              d="M148.943 133.927C148.417 134.057 147.925 134.277 147.495 134.575C147.065 134.874 146.706 135.244 146.438 135.665C146.17 136.086 145.999 136.55 145.933 137.03C145.868 137.51 145.91 137.997 146.057 138.463C146.205 138.928 146.454 139.364 146.791 139.744C147.129 140.124 147.548 140.442 148.024 140.679C148.5 140.915 149.024 141.067 149.567 141.124C150.109 141.181 150.659 141.143 151.184 141.013L167.192 137.044C168.254 136.781 169.154 136.156 169.694 135.305C170.234 134.455 170.371 133.449 170.074 132.509C169.776 131.57 169.07 130.773 168.109 130.295C167.148 129.816 166.012 129.695 164.951 129.959L148.943 133.927Z"
              fill="#FCC210"
            />
            <path
              d="M165.418 119.616L46.9619 148.98L47.2567 149.913L165.713 120.549L165.418 119.616Z"
              fill="#E6E6E6"
            />
            <path
              d="M284.406 244.943L274.905 246.976L261.525 215.503L275.547 212.502L284.406 244.943Z"
              fill="#A0616A"
            />
            <path
              d="M258.515 259L258.45 258.765C257.698 255.994 258.217 253.072 259.895 250.639C261.572 248.207 264.271 246.463 267.399 245.791L285.987 241.812L288.904 252.496L258.515 259Z"
              fill="#2F2E41"
            />
            <path
              d="M242.348 250.673L232.575 250.673L227.925 217.297L242.35 217.298L242.348 250.673Z"
              fill="#A0616A"
            />
            <path
              d="M244.716 258.95L213.451 258.949V258.707C213.451 255.856 214.731 253.122 217.008 251.106C219.285 249.09 222.373 247.958 225.593 247.958H225.593L244.717 247.959L244.716 258.95Z"
              fill="#2F2E41"
            />
            <path
              d="M227.917 237.644L218.427 137.516L257.712 131.105L257.867 131.081L269.366 137.624L265.363 174.474L283.79 231.925L267.879 235.632L249.423 182.349L245.2 166.146L243.035 187.201L244.642 239.124L227.917 237.644Z"
              fill="#2F2E41"
            />
            <path
              d="M217.21 139.787L217.106 139.671L230.682 49.1819L230.699 49.0633L230.795 48.9786C230.995 48.8014 235.752 44.6404 240.644 44.6404C241.351 44.6404 242.024 44.6246 242.669 44.6101C246.412 44.5239 249.37 44.455 252.884 47.567C256.465 50.7368 268.149 62.3121 268.149 78.1656C268.149 93.5104 269.727 141.197 269.743 141.677L269.765 142.35L269.127 141.983C268.97 141.893 253.256 133.035 240.076 141.269C235.958 143.843 232.258 144.745 229.094 144.745C221.731 144.745 217.273 139.858 217.21 139.787Z"
              fill="#FCC210"
            />
            <path
              d="M247.958 37.1738C257.447 32.5816 260.935 22.0489 255.747 13.6482C250.56 5.24762 238.663 2.16027 229.174 6.75247C219.685 11.3447 216.197 21.8774 221.384 30.2781C226.572 38.6787 238.469 41.766 247.958 37.1738Z"
              fill="#A0616A"
            />
            <path
              d="M208.591 159.234C209.517 158.598 210.275 157.791 210.81 156.868C211.346 155.945 211.647 154.929 211.691 153.893C211.735 152.856 211.522 151.823 211.067 150.867C210.612 149.911 209.925 149.055 209.056 148.359L220.176 125.138L205.616 127.511L197.288 149.198C196.065 150.568 195.452 152.289 195.565 154.033C195.679 155.777 196.511 157.423 197.904 158.66C199.297 159.897 201.154 160.639 203.124 160.745C205.094 160.851 207.039 160.313 208.591 159.234H208.591Z"
              fill="#A0616A"
            />
            <path
              d="M197.847 141.171L201.427 134.479C201.206 134.361 201.024 134.194 200.899 133.994C197.553 128.861 217.761 86.2353 219.108 83.408C218.903 81.8703 216.781 65.5751 218.332 60.0824C220.158 53.6165 223.907 50.6031 230.868 50.0062C238.545 49.368 240.616 58.5971 240.636 58.6908L240.643 82.4169L231.833 109.728L211.74 146.016L197.847 141.171Z"
              fill="#FCC210"
            />
            <path
              d="M241.07 28.4941C238.723 28.7644 236.952 26.6383 236.131 24.6729C235.31 22.7075 234.684 20.4194 232.643 19.3577C229.855 17.9073 226.287 19.6518 223.099 19.1732C219.498 18.6328 217.157 15.2545 216.974 12.0254C216.79 8.79629 218.242 5.69062 219.666 2.71344L220.163 6.4134C220.097 5.15939 220.395 3.91124 221.029 2.78836C221.663 1.66548 222.612 0.705415 223.785 0L223.144 5.42913C223.546 2.3876 227.247 0.0308173 230.632 0.661118L230.531 3.89598C234.69 3.45819 238.885 3.01978 243.056 3.35331C247.228 3.68685 251.428 4.85519 254.589 7.28709C259.318 10.9249 261.045 16.9148 260.465 22.4372C259.885 27.9595 257.311 33.1474 254.627 38.1589C253.952 39.4198 253.018 40.8426 251.452 41.0032C250.045 41.1476 248.758 40.1064 248.32 38.9139C247.883 37.7214 248.096 36.4258 248.358 35.1937C248.754 33.3323 249.253 31.4297 248.881 29.5645C248.509 27.6993 246.993 25.8561 244.869 25.6276C242.745 25.399 240.572 27.5481 241.593 29.2125L241.07 28.4941Z"
              fill="#2F2E41"
            />
            <path
              d="M326.791 258.989H185.88V257.97H327L326.791 258.989Z"
              fill="#3F3D56"
            />
          </g>
          <defs>
            <clipPath id="clip0_9157_38633">
              <rect width="327" height="259" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="my-6">
        <p class="text-primary-yellow font-semibold">Request Sent!</p>
        <p>{{ type }} receipt request sent successfully</p>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: "Handoff",
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}
</style>
